import React from 'react';
import { CalendarCheckIcon, GiftIcon, HouseIcon, MessageSquareIcon, RocketIcon, SquareStackIcon, UtensilsIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { BONOS_TOTAL, bonos } from '../../data/programa';
const icons = {
  rocket: RocketIcon,
  utensils: UtensilsIcon,
  cards: SquareStackIcon,
  calendar: CalendarCheckIcon,
  message: MessageSquareIcon,
  home: HouseIcon
} as const;
export function Bonuses() {
  return <section id="bonos" className="border-b border-line bg-navy py-[60px] lg:py-[100px]" data-id="element-41" data-mp="257he1fc5z5sn">
      <div className="mx-auto max-w-content px-6 text-center lg:px-10" data-id="element-42" data-mp="1w95e2mpeqvnj">
        <Reveal className="mx-auto max-w-2xl" data-id="element-43" data-mp="1w7c716avu9f0">
          <h2 className="flex items-center justify-center gap-3 text-3xl font-bold leading-tight tracking-tight text-ice sm:text-4xl" data-id="element-44" data-mp="1ralq6gr979sj">
            <GiftIcon className="h-8 w-8 shrink-0 text-gold" strokeWidth={1.5} aria-hidden="true" data-id="element-45" data-mp="kvl4r4zuua07" />
            6 Bonos Estratégicos
          </h2>
          <p className="mt-4 text-[12px] font-medium uppercase tracking-[0.1em] text-gold" data-id="element-46" data-mp="1eu6jex5pglnm">
            Siempre incluidos
          </p>
        </Reveal>

        <ul className="mx-auto mt-10 grid max-w-3xl grid-cols-2 gap-3 text-left sm:gap-4" data-id="element-47" data-mp="15t8meytopeej">
          {bonos.map((bono, index) => {
          const Icon = icons[bono.icon as keyof typeof icons];
          return <Reveal key={bono.number} delay={index * 0.04} as="li" className="h-full" data-id="element-48" data-mp="w2xbgsbl24y5" data-mpi={index}>
                <div className="flex h-full items-start gap-3 rounded-2xl border border-gold bg-white/[0.04] p-4 backdrop-blur-[10px]" data-id="element-49" data-mp="n2h437rpydo0">
                  <Icon className="mt-0.5 h-5 w-5 shrink-0 text-gold" strokeWidth={1.5} aria-hidden="true" data-id="element-50" data-mp="r542xsmt4yup" />
                  <div className="min-w-0" data-id="element-51" data-mp="i3ntpo7qb2s2">
                    <p className="text-[11px] font-medium uppercase tracking-[0.1em] text-gold" data-id="element-52" data-mp="i5h0r4m97p0l">
                      Bono {Number(bono.number)}
                    </p>
                    <h3 className="mt-1 text-[14px] font-semibold leading-snug text-ice" data-id="element-53" data-mp="2f11uft3vpeww">
                      {bono.title}
                    </h3>
                    {bono.description ? <p className="mt-1 text-[13px] leading-[1.5] text-cool" data-id="element-54" data-mp="26281qdto58om">
                        {bono.description}
                      </p> : null}
                    <p className="mt-2 text-[12px] text-cool" data-id="element-55" data-mp="2ypazh3qitfdt">
                      <span className="line-through" data-id="element-56" data-mp="2ynq6hijuu4i2">{bono.price}</span>{' '}
                      <span className="font-bold uppercase tracking-[0.1em] text-gold" data-id="element-57" data-mp="2tp6gn72548kf">
                        Gratis
                      </span>
                    </p>
                  </div>
                </div>
              </Reveal>;
        })}
        </ul>

        <Reveal delay={0.08} className="mx-auto mt-10 max-w-2xl" data-id="element-58" data-mp="1dbgalurgna85">
          <div className="rounded-2xl border border-gold bg-white/[0.04] px-8 py-6 backdrop-blur-[10px]" data-id="element-59" data-mp="138knqmknd403">
            <p className="text-[17px] text-cool" data-id="element-60" data-mp="187e3klnep73f">
              Valor total de los bonos{' '}
              <span className="line-through" data-id="element-61" data-mp="1d70j51qpizfe">{BONOS_TOTAL}</span> →{' '}
              <span className="text-xl font-bold uppercase tracking-[0.05em] text-gold" data-id="element-62" data-mp="1d4nrtxz27cpo">
                GRATIS
              </span>{' '}
              con tu Programa Atleta Corporativo
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}